// extracted by mini-css-extract-plugin
export default {"benefitsSection":"benefits_benefitsSection__lk+vO","benefitIcon":"benefits_benefitIcon__dnXjv"};